import { NgModule } from '@angular/core';
import { SessionTimeoutModalComponent} from './session-timeout-modal.component';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
@NgModule({
  declarations: [
    SessionTimeoutModalComponent,
  ],
  exports: [
    SessionTimeoutModalComponent,
  ],
  imports: [
    CommonModule,
    MatDialogModule,
  ]
})
export class SessionTimeoutModalModule { }
